export default __webpack_public_path__ + "static/media/okapp-avatar.f40276b2.png";